/* global System */
// register component(s) with react habitat

export default { MietparkSingle: () => System.import('./index') }
